module.exports = __webpack_public_path__ + "img/icon-horizontal-line-white.fad15a72.svg";